import {ChromoLogo, Logo, SelectableObject, StockLogo} from "../selectableObjects";
import {EventListener} from "../../global/eventVerteiler";
import {SelObTypes} from "../SelObTypes";
import {Entwurf} from "../entwurfsObjekt";
import {logIfDebug} from "../../global/logFunctions";
import globalsObject from "../globalsObject";
import {ColorUtils} from "../colorUtils";

export class StockLogoKopplungAnColorCodeHandler extends EventListener {
    private readonly getLogoObjects: () => (Logo | StockLogo | ChromoLogo)[];
    private readonly changeLogoColor: (id: string, colorCode: string, colorHexValue: string) => void;

    public constructor(getLogoObjects: () => (Logo | StockLogo | ChromoLogo)[], changeLogoColor:(id:string, colorCode:string, colorHexValue:string)=>void) {
        super();
        this.getLogoObjects = getLogoObjects;
        this.changeLogoColor = changeLogoColor;
        this.addEventListener("colorChangedEvent", (data: { colorHexValue: string, colorCode: string }) => {
            this.handleColorChange(data.colorCode, data.colorHexValue);
        })
            .addEventListener("logoColorChanged", (data:{selOb:SelectableObject, colors:{colorHexValue:string, colorCode:string}})=>{
                this.handleLogoColorChange(data.selOb, data.colors.colorCode, data.colors.colorHexValue);
        })
    }

    private handleColorChange(colorCode: string, colorHexValue: string) {
        const logos = this.getLogoObjects().filter(l => l.type === SelObTypes.STOCKLOGO) as StockLogo[];
        Entwurf.setCloneFlagsInArray(logos);

        logos.filter(l=>l.isClone === false).forEach(l => {
            this.testLogoColors(l, colorCode, colorHexValue);
        })
    }

    private testLogoColors(logo: StockLogo, colorCodeThatChanged: string, colorHexValue: string) {
        logo.colors.forEach(c => {
            if (!c.kopplungAufgehoben && c.kopplungAnColorCode === colorCodeThatChanged) {
                this.changeLogoColor(logo.id, c.colorCode, colorHexValue)
            }
        })
    }

    private handleLogoColorChange(selOb: SelectableObject, colorCode: string, colorHexValue: string) {
        if(selOb.type!== SelObTypes.STOCKLOGO) {
            return;
        }
        const logoColor = (selOb as StockLogo).colors.find(c=>c.colorCode === colorCode) ||
            (selOb as StockLogo).colors.find(c=>c.colorCode === '#'+colorCode);

        if(!logoColor) {
            logIfDebug("colorCode on logo not found: "+selOb.id + "; "+colorCode)
        }
        if(logoColor.kopplungAnColorCode !== null) {
            const color = globalsObject.controller.model.entwurf.getColorObjectByColorCode(logoColor.kopplungAnColorCode);
            logoColor.kopplungAufgehoben = ColorUtils.decToHex(color.colorValue) !== colorHexValue.replace("#", "");
            selOb.cloneIds.forEach(cloneID=>{
                const clone = (globalsObject.controller.model.entwurf.getSelectableObject(cloneID) as StockLogo);
                const cloneColor = (clone as StockLogo)
                    .colors.find(c=>c.colorCode === c.colorCode) || (clone as StockLogo).colors.find(c=>c.colorCode === '#'+colorCode);
                cloneColor.kopplungAufgehoben = logoColor.kopplungAufgehoben;
            })
        }
    }
}